import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'

interface Props {
  shortErrorMessage?: string
  children?: () => ReactElement
  onSuccess?: () => void
  id: string
}

const DeleteTestConfigRequest = ({
  shortErrorMessage,
  children,
  onSuccess,
  id
}: Props) => {
  const url = `${TEST_CONFIG_SERVICE}/test_configurations/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onSuccess={onSuccess}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default DeleteTestConfigRequest
